import { Injectable, Inject, ElementRef, Renderer } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { APIServices } from '../../../config/app-config';
import { AppTranslateService } from '../translate/translate.service';
import { InputDatepickerService } from '../forms/input-datepicker/services/input-datepicker.service';
import { SwUpdate } from '@angular/service-worker';
import { Observable, Subject, throwError } from 'rxjs';
import { map, catchError, filter } from 'rxjs/operators';

@Injectable()
export class AppService {
  sidebarListPlane;
  pageView: string;
  sectionView: string;
  breadCrumb = [];
  breadCrumbMobile = '';
  iconBreadCrumb: string;
  mobileDevice = false;
  loading: boolean = false;
  userInfo;
  pageInfo: string;
  isLogged = false;
  sidebarList;
  existMenu = false;
  MultiUser: boolean = false;
  actualUrl = null;
  version = '1.3.13';

  detectChangesAppSubject: Subject<any> = new Subject<any>();
  detectChangesAppStream: Observable<any> = this.detectChangesAppSubject.asObservable();

  // Url where user is trying to navigate before login
  navigationUrl: string = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: WebStorageService,
    private translate: AppTranslateService,
    private inputDatepickerService: InputDatepickerService,
    private swUpdate: SwUpdate
  ) {

    // Event fired every navigation finish
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.setLoadingFalse();
        if (event.url != '/' && this.sidebarListPlane) {
          this.getTitle();
        }
        if (!this.actualUrl || this.actualUrl.split('/')[1] != event.url.split('/')[1]) {
          this.cleanGridCache();
        }
        this.actualUrl = event.url;
        this.checkUser();
        this.detectChangesApp();
      });

    // Event fired every navigation start
    router.events
      .pipe(
        filter(event => event instanceof NavigationStart)
      )
      .subscribe((event: NavigationStart) => {
        if (event.url !== '/') {
          this.setLoadingTrue();
          this.pageInfo = null;
        }
      });

    this.swUpdate.available.subscribe(evt => {
      console.log('Service-Worker update detected -> window reload');
      window.location.reload();
    });
  }

  setLoadingTrue() {
    this.loading = true;
    this.detectChangesApp();
  }

  setLoadingFalse() {
    this.loading = false;
    this.detectChangesApp();
  }

  detectChangesApp() {
    this.detectChangesAppSubject.next();
  }

  cleanGridCache() {
    if (this.storage.get('cacheGridKey')) {
      this.storage.remove(this.storage.get('cacheGridKey'));
      this.storage.remove(this.storage.get('cacheGridKey') + 'QuickSearch');
      this.storage.remove(this.storage.get('cacheGridKey') + 'Sorting');
      this.storage.remove(this.storage.get('cacheGridKey') + 'PageSize');
    }
  }

  getUserMenu(): Observable<any> {
    let usr = this.getFromLocal(environment.userStorage);
    
    /*let formData = new FormData();
    formData.append('UserId', usr.userId.toString());
    formData.append('ModuleId', environment.moduleId.toString());*/

    return this.http
      //.post(APIServices.admin.common.GetMenuByUser, formData)
      .get(APIServices.admin.common.GetMenuByUser)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          if (error.status == 401) {
            this.saveInLocal(environment.userStorage, null)
            this.router.navigate['login'];
          } else {
            return throwError(new Error(error));
          }
        })
      );
  }

  async checkLogged() {
    if (this.getFromLocal(environment.userStorage) != null) {
      this.isLogged = true;
      if (this.existMenu == false) {
        await this.getSidebar();
      }
    } else {
      this.isLogged = false;
    }
  }

  async getSidebar() {
    let result = await this.getUserMenu().toPromise();
    if (result != null) {
      this.sidebarList = this.translateMenuItems(result);
      this.getTitle();
      this.existMenu = true;
    } else {
      this.isLogged = false;
    }
  }

  translateMenuItems(menuItems) {

    this.sidebarListPlane = [];
    menuItems.forEach(element => {
      element.name = element.title;
      // element.Title = this.translate.translateText('Shared.Navbar.' + element.Title);
      this.sidebarListPlane.push(element);
      if (element.hijos != null) {
        element.hijos.forEach(listChild => {
          // listChild.Title = this.translate.translateText('Shared.Navbar.' + listChild.Title);
          this.sidebarListPlane.push(listChild);
          if (listChild.hijos != null) {
            listChild.hijos.forEach(children => {
              // children.Title = this.translate.translateText('Shared.Navbar.' + children.Title);
              this.sidebarListPlane.push(children);
            });
          }
        });
      }
    });
    return menuItems;
  }

  checkUser() {
    if (this.getFromLocal(environment.userStorage) == null) {
      if (this.actualUrl && this.actualUrl != '/login' && this.actualUrl != '/login/login') {
        this.navigationUrl = this.actualUrl;
        this.router.navigate(['/login']);
      }
    } else {
      this.userInfo = this.getFromLocal(environment.userStorage);
      this.defineInternationalization(this.getInternationalizationType(this.userInfo.languageId));

      if (this.userInfo.version != this.version && this.swUpdate.isEnabled) {
        this.swUpdate.checkForUpdate().then(() => this.swUpdate.activateUpdate().then(() => document.location.reload()));
      }
    }
  }

  getInternationalizationType(langualeCode) {
    if (langualeCode.toUpperCase() == 'EN') return 'gb-GB';
    //English
    else return 'es-ES'; // Spanish
  }

  defineInternationalization(langualeCode) {
    this.inputDatepickerService.setInternationalization(langualeCode);
  }

  // Create Bread Crumbs
  getTitle() {
    let constante = '/';
    let path = window.location.pathname.split(constante).filter(x => x && !+x);
    let pathActual = '';
    this.pageView = path[0];
    this.breadCrumb = [];
    let navigationPath = '';

    // No generamos breadcrum en la página de login
    if (path[path.length - 1] != '' && path[path.length - 1] != 'login') {
      // Recorremos todos los elementos de la ruta
      for (let i = 0; i < path.length; i++) {
        // Eliminamos parámetros de la ruta actual
        if (path[i].indexOf(';') > 0) {
          pathActual = path[i].split(';')[0];
        } else {
          pathActual = path[i];
        }

        // Buscamos el icono si es el primer elemento del enlace
        if (i == 0) {
          if (this.sidebarListPlane.filter(x => x.name == pathActual).length > 0) {
            this.iconBreadCrumb = '<i class=\'fa fa-' + this.sidebarListPlane.filter(x => x.name == pathActual)[0].icon + '\'></i>';
          }
        }
        // Creamos el rastro de migas para todos los elementos
        if (i + 1 == path.length) {
          this.breadCrumb.push({
            innerHtml: '<a class=\'fontActual\'>' + this.translate.translateText('Shared.BreadCrumb.' + pathActual) + '</a>',
            route: null
          });
          this.breadCrumbMobile = '<a data-link=\'/' + pathActual + '\' class=\'fontActual\'>' + this.translate.translateText('Shared.BreadCrumb.' + pathActual) + '</a>';
        } else {
          navigationPath += '/' + pathActual;
          this.breadCrumb.push({
            innerHtml: '<a class=\'navigateBreadCrumb\'>' + this.translate.translateText('Shared.BreadCrumb.' + pathActual) + '</a><i class=\'fa fa-angle-right arrowSidebar\'></i>',
            route: navigationPath
          });
        }
      }
    }

    this.sectionView = pathActual;
  }

  saveInLocal(key, val) {
    this.storage.set(key, val);
    if (key == environment.userStorage) {
      this.userInfo = val;
    }
  }

  getFromLocal(key) {
    if (key == environment.userStorage) {
      this.userInfo = this.storage.get(key);
    }
    return this.storage.get(key);
  }

  setEntity(params: any) {
    window.sessionStorage.setItem(params.NameEntity, JSON.stringify(params));
  }

  getEntity(nameEntity: string) {
    return window.sessionStorage.getItem(nameEntity);
  }

  getSelectListRegionByServ(param: number) {
    return this.http
      .get(APIServices.common.GetRegionByServ + '?CdServ=' + param)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

  getSelectListProvinceByServ(param: number) {
    return this.http
      .get(APIServices.common.GetProvinceByServ + '?CdServ=' + param)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

  getSelectListMuniByServ(param: number) {
    return this.http
      .get(APIServices.common.GetMuniByServ + '?CdServ=' + param)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

  checkPerm(idPerm: number) {
    if (!this.userInfo)
      this.checkUser();

    if (this.userInfo) {
      let perm = this.userInfo.RolesAndPermissions.filter(x => x.Id == idPerm);
      if (perm && perm.length > 0) {
        return true;
      }
    }
    return false;
  }


  insertConfigGrid(configGrid: any): Observable<any> {
    return this.http.post(APIServices.nota.customers.insertConfigGrid, configGrid)
    .pipe(
      map(result => {
        return result;
      }),
      catchError(error => {
        return throwError(new Error(error));
      })
    );
  }

  getConfigGrid(NameGrid: string) {
    return this.http
      .get(APIServices.nota.customers.GetConfigGrid + '?NameGrid=' + NameGrid)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

  GetAllConfigGrid() {
    return this.http
      .get(APIServices.nota.customers.GetAllConfigGrid)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

}
